import React from "react";
import { Tag, Popconfirm } from "antd";
import { renderIcon, renderTableText } from "../../../lib/utils";
import { FiEdit3 } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

const EditIcon = renderIcon(FiEdit3);
const DeleteIcon = renderIcon(RiDeleteBin6Line);

const BuildingsCard = ({
  data,
  form,
  setIsEditing,
  handleDelete,
}: any) => {

  const navigate = useNavigate();

  return (
    <div className="bg-[#F9F9F9] p-3 rounded-lg shadow space-y-2">
      <p className="font-semibold text-base text-primary">
        {renderTableText(data?.buildingName)}
      </p>

      <p className="text-gray-700 text-sm">
        <span className="font-semibold">Site Managers: </span>
        {data?.siteManagerNameList?.map((item: any) =>  <Tag color="blue">{item.name}</Tag> )}
      </p>

      

      <p className="text-gray-700 text-sm">
        <span className="font-semibold">Location: </span>
        {renderTableText(data?.location)}
      </p>

      <p>
        <span className=" font-semibold"> Status : </span>
        <Tag color={data?.status ? "green" : ""} bordered>
          {data?.status ? "Completed" : "In Progress"}
        </Tag>
      </p>

      <div className="flex justify-end gap-4 mt-3 text-primary">
        <EditIcon
          className="cursor-pointer text-[20px]"
          onClick={() => navigate(`/buildings/edit/${data?._id}`)}
        />

        <Popconfirm
          title="Are you sure to delete this row?"
          onConfirm={() => handleDelete(data?._id)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteIcon className="cursor-pointer text-red-600 text-[20px]" />
        </Popconfirm>
      </div>
    </div>
  );
};

export default BuildingsCard;
